export default __webpack_public_path__ + "static/media/zion fluted panel.8150ee11.png";